export const getAddressPieces = ({ address, city, state, zipcode }) =>
  [
    address,
    [[city, state].filter(Boolean).join(', '), zipcode]
      .filter(Boolean)
      .join(' '),
  ].filter(Boolean)
